<script>
  import { onMount } from 'svelte';
  import { slide } from 'svelte/transition';
  import { Card, CardBody, CardFooter, CardHeader, Pagination, PaginationItem, PaginationLink, Table, Button, Spinner, CustomInput} from 'sveltestrap';
  import {downloadByteArray} from '../common/helpers/CSVHelper.js';
  import WidgetCardAlt from '../components/WidgetCardAlt.svelte';
  import Filter from '../components/Filter.svelte';
  import Search from '../components/Search.svelte';
  import ManageComputerAttributesModal from '../modals/ManageComputerAttributesModal.svelte';
	import TableColumn from '../components/TableColumn.svelte';
  import http from '../api/http.js';
  import { selectedGroup, currentPage } from '../store.js'; 
  import Tooltip from '../reusable components/tooltip.svelte';
  import DeleteComputerModal from "../modals/DeleteComputerModal.svelte";
	import ComputerDropdownRow from '../components/ComputerDropdownRow.svelte';
  import ComputerSettingsModal from '../modals/ComputerSettingsModal.svelte';
  import UnmanagedEndpoints from './UnmanagedEndpoints.svelte';
	import prettysize from 'prettysize';
  import { branding } from '../store.js';

  let searchTerm = "";
  let computers = [];
  let selectedComputers = [];
  let pageNumber = 1;
  let totalPageCount = 0;
  let totalComputerCount = 0;
  let inputLength = 0;
  let searchRefresh = false;
  let showAttributes = false;
  let uniqueAttributeNames = [];
  let manageComputerAttributeModal;
  let allComputersSelected = false;
  let previousPageNumber = 0;
  let kioskStatus = "";
  let stateLegend = [
    {
      "name": "",
      "icon": "circle",
      "iconType": "fad",
      "value": "Within last 24 hours.",
      "color": "info"
    },
    {
      "name": "",
      "icon": "circle",
      "iconType": "fad",
      "value": "Over 24 hours ago.",
      "color": "warning"
    },
    {
      "name": "",
      "icon": "circle",
      "iconType": "fad",
      "value": "Over 48 hours ago.",
      "color": "danger"
    }
  ];
  let kioskStateLegend = [
    {
      "name": "",
      "icon": "desktop",
      "iconType": "fad",
      "value": "Kiosk.",
      "color": ""
    },
    {
      "name": "",
      "icon": "desktop",
      "iconType": "fad",
      "value": "Duplicate Kiosk.",
      "color": "danger"
    }
  ];

  let tableHeader = managedFilterState;
  let isLoading = false;

  let filterState = managedFilterState;

  $:tableHeader;
  $:filterState;

  const managedFilterState = 'Managed Endpoints';
  const outdatedVersionFilterState = `Endpoints Running Outdated Versions Of ${$branding.name}`;
  const unmanagedFilterState = 'Unmanaged Endpoints';

  let managedEndpointCount = 0;
  let outdatedVersionEndpointCount = 0;
  let unmanagedEndpointCount = 0;

  let selectedDeployVersion = "";
  let selectedOperatingSystem = "";
  let selectedProcessor = "";
  let selectedRamSize = 0;

  let useEnhancedFilters = false;

  let useEnhancedFilterDeployVersion = false;
  let useEnhancedFilterOperatingSystem = false;
  let useEnhancedFilterProcessor = false;
  let useEnhancedFilterRamSize = false;

  let refinedCriteria;

  $:refinedCriteria;

  const setFilterState = (state) => {
    filterState = state;

    if (filterState == managedFilterState || filterState == outdatedVersionFilterState) {
      loadComputers(activeColumn.columnValue, activeColumn.sortType);
    }
    tableHeader = filterState;
  }

  let filtersExpanded = false;

  const displayNumbers = [10, 25, 50, 100, 200];

  let displayNumber = displayNumbers[0];

  let sortType = {
      ascending: 'ascending',
      descending: 'descending',
      resting: 'resting'
    }

  let activeColumn = {
    columnValue: 0,
    sortType: sortType.ascending,
  };

  let deleteComputerModal;
  let computerSettingsModal;

  function toggleSort(columnValue, theSortType) {
    if (activeColumn.value != columnValue) {
      activeColumn.columnValue = columnValue;
    }
    switch(theSortType) {
      case sortType.resting:
        activeColumn.sortType = sortType.ascending;
        break;
      case sortType.ascending:
        activeColumn.sortType = sortType.descending;
        break;
      case sortType.descending:
        activeColumn.sortType = sortType.ascending;
        break;
    }

    if (activeColumn.sortType != sortType.resting){
      loadComputers(columnValue, activeColumn.sortType);
    }
    else {
      activeColumn.columnValue = 0;
      activeColumn.sortType = sortType.ascending;
      loadComputers(0, activeColumn.sortType);
    }
  }

  $:activeColumn;

  $:uniqueAttributeNames;
  
  const toggleAttributes = () => {
    showAttributes = !showAttributes;
  }

    $: {    
      displayNumber;
      if (pageNumber != previousPageNumber) {
        allComputersSelected = false;
        previousPageNumber = pageNumber;
      }
      if ($selectedGroup != undefined) {
          getRefinedSearchCriteria();
          handleColumnVisibility();
          loadComputers(activeColumn.columnValue, activeColumn.sortType);
          getCounts();
          getUniqueAttributeNames();
    }      
  } 
  
  async function getUniqueAttributeNames() {
    try {  
      const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/attribute/computer/names/${$selectedGroup}`);
      uniqueAttributeNames = await res.json();        
    } 
    catch (error) {
      uniqueAttributeNames = [];
    }
  }

  async function loadComputersAndAttributes() {
    await loadComputers(activeColumn.columnValue, activeColumn.sortType);
    await getUniqueAttributeNames();
    selectedComputers.forEach(computer => {
      computer.selected = false;
    });
    selectedComputers = [];
    selectedComputers = selectedComputers;
    computers.forEach(computer => {
      computer.selected = false;
    });
    computers = computers;
  }

  async function loadComputers(columnValue, sortTypeArg) {
    let params = "";
    if(computers.length > 0) {
        params = {
        deployVersion: useEnhancedFilterDeployVersion ? selectedDeployVersion : "",
        operatingSystem: useEnhancedFilterOperatingSystem ? selectedOperatingSystem : "",
        processor: useEnhancedFilterProcessor ? selectedProcessor : "",
        ramSize: useEnhancedFilterRamSize ? selectedRamSize : ""
      }
    }
    else{
      useEnhancedFilterDeployVersion = false;
      useEnhancedFilterOperatingSystem = false;
      useEnhancedFilterProcessor = false;
      useEnhancedFilterRamSize = false;
    }
    
    const queryString = new URLSearchParams(params).toString();
    let previousFilterState = filterState;
    let outdated = filterState == outdatedVersionFilterState ? true : false;

    if(previousFilterState != filterState){
      pageNumber = 1;
    }
    isLoading = true;
    if ({$selectedGroup} != undefined) {
      let ascending = sortTypeArg == sortType.ascending ? true : false;
      if(columnValue == undefined){
         columnValue = 0;
      }
      if(ascending == undefined){
         ascending = true;
      }
      const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/computers/${$selectedGroup}/${searchTerm.length > 0 && searchTerm != "" ? `${searchTerm.toLocaleLowerCase()}/` : ""}${displayNumber}/${pageNumber}/${columnValue}/${ascending}/${outdated}?${queryString}`);
      
      if (res.status == 200) {
        let uiComputerCollection = await res.json();
        computers = uiComputerCollection.computers;
        totalPageCount = uiComputerCollection.totalPageCount;
        totalComputerCount = uiComputerCollection.noPaginationComputerCount;
        checkStoredComputers();
      }
      else if (res.status == 404) {
        computers = [];
        totalPageCount = 0;
        totalComputerCount = 0;
      }
    }
    isLoading = false;
  }
  
  function setPageNumber(number) {
    pageNumber = number;    
  }

  async function searchComputers() { 
    searchRefresh = true;    
    let interval = setInterval( async () => {
      if (searchTerm.length != inputLength) {
        pageNumber = 1;
        loadComputers(activeColumn.columnValue, activeColumn.sortType);   
      }  
       
      if (!searchRefresh) {
        clearInterval(interval);
      }
      inputLength = searchTerm.length;      
    }, 2000);    
  }

   function toggleSelectAllcomputers() {
    if (allComputersSelected) {
       computers.forEach(computer => {
        computer.selected = true;
        if(!selectedComputers.map(c => c.id).includes(computer.id)){
          selectedComputers.push(computer);
        }
      });
    }
    else {
        computers.forEach(computer => {
        computer.selected = false;
        selectedComputers = selectedComputers.filter(c => c.id != computer.id);
      });
    }
    computers = computers;
    selectedComputers = selectedComputers;
  }

  function selectComputer(computer) {
    if (computer.selected) {
      selectedComputers.push(computer);
    }
    else{
      selectedComputers = selectedComputers.filter(c => c.id != computer.id);
    }
    selectedComputers = selectedComputers;
    computers = computers;
  }

  function checkStoredComputers() {
    computers.forEach(computer => {
      if(selectedComputers.map(c => c.id).includes(computer.id)){
        computer.selected = true;
      }
    });
  }
  
  let columns = [
      {name: "Endpoint Name", visible: true, value: 0, sortable: true, hasLegend: false, legend: []},
      {name: "Vessel Name", visible: true, value: 2, sortable: true, hasLegend: false, legend: []},
      {name: "Deploy Version", visible: true, value: 3, sortable: true, hasLegend: false, legend: []},
      {name: "Last Reported", visible: true, value: 4, sortable: true, hasLegend: true, legend: stateLegend},
      {name: "Installed Memory", visible: true, value: 5, sortable: true, hasLegend: false, legend: []},
      {name: "Processor", visible: true, value: 6, sortable: true, hasLegend: false, legend: []},
      {name: "Operating System Name", visible: true, value: 7, sortable: true, hasLegend: false, legend: []},
      {name: "Attribute Count", checked: true, value: 0, sortable: false, hasLegend: false, legend: []}
  ]

  $:columns

  function handleColumnVisibility() {
      columns.forEach(column => {
          let value = localStorage.getItem(column.name);
          if (value == "true" || value == null) {
              column.visible = true;
          }
          else {
              column.visible = false;
          }
      })

      columns = columns;
  }

  async function getComputerCSV() {
    let params = {
      deployVersion: useEnhancedFilterDeployVersion ? selectedDeployVersion : "",
      operatingSystem: useEnhancedFilterOperatingSystem ? selectedOperatingSystem : "",
      processor: useEnhancedFilterProcessor ? selectedProcessor : "",
      ramSize: useEnhancedFilterRamSize ? selectedRamSize : ""
    }

    const queryString = new URLSearchParams(params).toString();

    let outdated = filterState == outdatedVersionFilterState ? true : false;
    let csv = columns.filter(column => column.visible && column.name != "Attribute Count").map(column => column.name).join(",");

    const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/computers/csv/${$selectedGroup}/${csv}/${outdated}?${queryString}`);
    
    if (res.status == 200) {
      let data = await res.json();
      downloadByteArray("Endpoints.csv", data, "text/csv");
    }
  }

  async function getCounts() {
    let params = {
      deployVersion: useEnhancedFilterDeployVersion ? selectedDeployVersion : "",
      operatingSystem: useEnhancedFilterOperatingSystem ? selectedOperatingSystem : "",
      processor: useEnhancedFilterProcessor ? selectedProcessor : "",
      ramSize: useEnhancedFilterRamSize ? selectedRamSize : ""
    }

    const queryString = new URLSearchParams(params).toString();

    const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/computers/computercounts/${$selectedGroup}/${useEnhancedFilters}?${queryString}`);
    if(res.status == 200) {
      let counts = await res.json();
      managedEndpointCount = counts.managedCount;
      outdatedVersionEndpointCount = counts.outdatedCount;
      unmanagedEndpointCount = counts.unmanagedCount;
    }
  }

  async function getRefinedSearchCriteria() {
    const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/computers/refinedsearchcriteria/${$selectedGroup}`);
    if (res.status == 200) {
      refinedCriteria = await res.json();
      selectedDeployVersion = refinedCriteria.deployVersions[0];
      selectedOperatingSystem = refinedCriteria.operatingSystems[0];
      selectedProcessor = refinedCriteria.processors[0];
      selectedRamSize = refinedCriteria.ramSizes[0];
    }
  }

  async function handleApplyFilters() {
    useEnhancedFilters = true;
    pageNumber = 1;
    loadComputers(activeColumn.columnValue, activeColumn.sortType);
    getCounts();
  }

  async function clearFilters() {
    useEnhancedFilters = false;
    useEnhancedFilterDeployVersion = false;
    useEnhancedFilterOperatingSystem = false;
    useEnhancedFilterProcessor = false;
    useEnhancedFilterRamSize = false;
    loadComputers(activeColumn.columnValue, activeColumn.sortType);
    getCounts();
  }
  
  onMount(async () => {     
    currentPage.set('computers');
  });
  </script>

  <div class="d-flex align-items-center mb-2">
    <h4 class="font-weight-bold text-primary">Endpoints</h4>
    {#if filterState != unmanagedFilterState}
        <button class="btn btn-primary ml-auto d-flex justify-center" on:click={() => computerSettingsModal.showModal()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="mr">
          <path d="M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> 
          Column Settings
        </button>
      {/if}
  </div>

  <div class="d-flex">
    <Filter title="Filter Endpoints" on:mousedown={() => filtersExpanded = !filtersExpanded} isfiltering={useEnhancedFilters}></Filter>
  </div>
  {#if filtersExpanded}
    <div class="d-flex mt-4" id="filters" in:slide>
      <div class="form-group mr-4">
        <label class="d-flex" for="deploy-version">
          {$branding.name} Version
          <CustomInput type="switch" class="ml-auto" checked={useEnhancedFilterDeployVersion} on:change={() => useEnhancedFilterDeployVersion = !useEnhancedFilterDeployVersion} id="deploy-version"></CustomInput>
        </label>
        <select class="form-control" bind:value={selectedDeployVersion} disabled={!useEnhancedFilterDeployVersion}>
          {#each refinedCriteria.deployVersions as version}
            <option value={version}>{version}</option>
          {/each}
        </select>
      </div>
      <div class="form-group mr-4">
        <label class="d-flex" for="operating-system">
          Operating System
          <CustomInput type="switch" class="ml-auto" checked={useEnhancedFilterOperatingSystem} on:change={() => useEnhancedFilterOperatingSystem = !useEnhancedFilterOperatingSystem} id="operating-system"></CustomInput>
        </label>
        <select class="form-control" bind:value={selectedOperatingSystem} disabled={!useEnhancedFilterOperatingSystem}>
          {#each refinedCriteria.operatingSystems as os}
            <option value={os}>{os}</option>
          {/each}
        </select>
      </div>
      <div class="form-group mr-4">
        <label class="d-flex" for="processor">
          Processor
          <CustomInput type="switch" class="ml-auto" checked={useEnhancedFilterProcessor} on:change={() => useEnhancedFilterProcessor = !useEnhancedFilterProcessor} id="processor"></CustomInput>
        </label>
        <select class="form-control" bind:value={selectedProcessor} disabled={!useEnhancedFilterProcessor}>
          {#each refinedCriteria.processors as processor}
            <option value={processor}>{processor}</option>
          {/each}
        </select>
      </div>
      <div class="form-group mr-4">
        <label class="d-flex" for="installed-memory">
          Installed Memory
          <CustomInput type="switch" class="ml-auto" checked={useEnhancedFilterRamSize} on:change={() => useEnhancedFilterRamSize = !useEnhancedFilterRamSize} id="ram-size"></CustomInput>
        </label>
        <select class="form-control" bind:value={selectedRamSize} disabled={!useEnhancedFilterRamSize}>
          {#each refinedCriteria.ramSizes as ramSize}
            <option value={ramSize}>{prettysize(ramSize)}</option>
          {/each}
        </select>
      </div>

      <div class="mr-2">
        <button class="btn btn-primary filter-button" on:click={() => handleApplyFilters()}>Apply Filters</button>
      </div>
      <div>
        <button class="btn btn-outline-primary filter-button" on:click={() => clearFilters()} disabled={!useEnhancedFilters}>Clear Filters</button>
      </div>
    </div>
    <hr class="m-2">
  {/if}

  <div class="grid">
    <WidgetCardAlt isWidget="true" title="Managed Endpoints" icon="desktop" value="{managedEndpointCount}" color="primary" active={filterState == managedFilterState} on:mousedown={() => setFilterState(managedFilterState)}></WidgetCardAlt>
    <WidgetCardAlt isWidget="true" title={outdatedVersionFilterState} icon="exclamation-circle" value="{outdatedVersionEndpointCount}" color="secondary" active={filterState == outdatedVersionFilterState} on:mousedown={() => setFilterState(outdatedVersionFilterState)}></WidgetCardAlt>
    <WidgetCardAlt isWidget="true" title="Unmanaged Endpoints" icon="question-circle" value="{unmanagedEndpointCount}" color="tertiary" active={filterState == unmanagedFilterState} on:mousedown={() => setFilterState(unmanagedFilterState)}> ></WidgetCardAlt>
  </div>

  {#if filterState != unmanagedFilterState}
  <Card class="shadow mb-4">
    <CardHeader>
      <div class="row">
        <div class="col-sm d-flex">
            <h6 class="font-weight-bold mt-2 mb-2 mr-2">{tableHeader}</h6>
            <Tooltip content={kioskStateLegend} legend={true} title={"Kiosk States"}>
              <i class="fa fa-question-circle mt-2 mb-2"></i>
            </Tooltip>
        </div>
        {#if isLoading}
          <Spinner color="primary" type="border"></Spinner>
        {/if}
         <div class="col-sm">
            <Search id="computers-search-input" bind:searchTerm on:focusout={() => searchRefresh =  false} on:input={() => searchComputers()} placeholder="Search Endpoints..."></Search>      
         </div>
        <div class="col-sm">
          <div class="float-right">
            <button id="manage-computer-attributes-button" class="btn btn-link mr" on:click={() => manageComputerAttributeModal.show(selectedComputers, searchTerm)}>Manage Attributes</button>
            <button id="export-csv-button" class="btn btn-primary" disabled={computers.length === 0} on:click={()=> getComputerCSV()}>Export CSV</button>
          </div>
        </div>
      </div>
    </CardHeader>
    <CardBody>
      <Table responsive>
        <thead>
          <th></th>
          <th><input type="checkbox" class="mr-2" bind:checked={allComputersSelected} on:change={() => toggleSelectAllcomputers()}>{selectedComputers.length > 0 ? `(${selectedComputers.length})` : ""}</th>
            {#each columns as column}
              {#if column.visible}
                {#if column.name != "Attribute Count"}
                    <TableColumn  on:mousedown={() => toggleSort(column.value, activeColumn.sortType)} active={activeColumn.columnValue == column.value} sortType={activeColumn.sortType}>{column.name === "Deploy Version" ? `${$branding.name} Version` : column.name}
                      {#if column.hasLegend}
                        <Tooltip legend={column.legend} title={column.name} content={column.legend}><i class="fa fa-question-circle"></i></Tooltip>
                      {/if}
                    </TableColumn>
                  {:else}
                  <th class="pointer" on:mousedown={() => toggleAttributes()}>{column.name} <i class="fa fa-caret-{showAttributes == true ? "left" : "right"}"></i></th>
                {/if}
              {/if}
            {/each}
            {#if showAttributes}
              {#each uniqueAttributeNames as uniqueAttributeName}
                <th>{uniqueAttributeName}</th>
              {/each}
            {/if}    
            <th/>
        </thead>    
        <tbody>
          {#if computers.length > 0}
            {#each computers as computer}
              <ComputerDropdownRow visibleColumns={columns} computer={computer} on:deleteComputer={() => deleteComputerModal.show(computer)} on:selectComputer={() => selectComputer(computer)} uniqueAttributeNames={uniqueAttributeNames} showAttributes={showAttributes}/>  
            {/each}
          {:else}
              <td colspan="10" class="text-center">No endpoints to show</td>
          {/if}
        </tbody> 
      </Table>
    </CardBody>
    <CardFooter>      
      <div class="pagination bg-light shadow-none ml-0 d-flex">
        <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalComputerCount ? totalComputerCount:pageNumber * displayNumber)} of {totalComputerCount} computers</small>
        <div class="mt-2 justify-content-center">
          <Pagination>
            <PaginationItem disabled={pageNumber == 1}>
              <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
            </PaginationItem>

            <PaginationItem  disabled={pageNumber == 1}>
              <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
            </PaginationItem>

            {#if totalPageCount > 5}
              {#each Array(5) as _, count}
                {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                  <PaginationItem active={pageNumber == count + pageNumber} >
                    <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber <= 3}
                  <PaginationItem active={pageNumber == count + 1} >
                    <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber >= totalPageCount - 2}
                  <PaginationItem active={pageNumber == totalPageCount - 4 + count} >
                    <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                  </PaginationItem>
                {/if}
              {/each}
            {:else}
              {#each Array(totalPageCount) as _, count}
                <PaginationItem active={pageNumber == count + 1} on:click={() => pageNumber == count + 1}>
                  <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                </PaginationItem>
              {/each}
            {/if}      

            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
            </PaginationItem>
            
            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
            </PaginationItem>
          </Pagination>
        </div>
        <div class="mt-2 ml-auto">
          <select class="form-select" id="display-number-select" bind:value={displayNumber}>
            {#each displayNumbers as displayNumber}
              <option value={displayNumber}>{displayNumber}</option>
            {/each}
          </select>
          <label class="ml-1" id="displayNumberLabel" for="display-number-select">Per page</label>     
        </div>  
      </div>
    </CardFooter>
  </Card>
  {:else}
    <UnmanagedEndpoints byVessel={false}></UnmanagedEndpoints>
  {/if}

<ManageComputerAttributesModal bind:this={manageComputerAttributeModal} on:computerAttributesUpdated={() => loadComputersAndAttributes()}></ManageComputerAttributesModal>
<DeleteComputerModal on:computerDeleted={() => loadComputers(activeColumn.columnValue, activeColumn.sortType)} bind:this={deleteComputerModal}></DeleteComputerModal>
<ComputerSettingsModal bind:this={computerSettingsModal} on:close={() => handleColumnVisibility()} brandName={$branding.name} columns={columns}></ComputerSettingsModal>

<style>  
  #display-number-select{
    max-height: 30px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #DEDEDE;
    height:400px;
    color:#3a3a3a;
  }
  .grid {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      display: grid;
      gap: 2.5em;
      margin-top: 1.5em;
      margin-bottom: 1.5em;
  }
  .filter-button{
    margin-top: 30px;
  }

  #filters select{
    min-width: 250px;
  }

</style>